import { AnyAction } from "redux";

import { stationsActions } from "../reducer";

export const resetStationWithPrices = (): AnyAction =>
  stationsActions.resetStationWithPrices();
